import React, { useEffect, useRef } from "react";
import { apiUrl } from "../../commons/inFormTypes";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageContext";

const GOOGLE_CLIENT_ID = "1091084264650-s7rukcupp2n6u3bmhokbt8gd4al8vkce.apps.googleusercontent.com";

const GoogleLoginButton = ({ text = "signin_with", redirectTo = "/user/dashboard" }) => {
    const btnRef = useRef(null);
    let navigate = useNavigate();
    const { isEnglish } = useLanguage();

    useEffect(() => {
        const handleCredential = async (response) => {
            const res = await fetch(apiUrl + "auth/GoogleSignIn", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ credential: response.credential }),
            });

            if (res.ok) {
                const data = await res.json();
                const cookies = new Cookies();
                cookies.set("token", data.token, { path: "/" });
                cookies.set("role", data.role, { path: "/" });
                if (data.role === "Admin") {
                    navigate(redirectTo || "/mainadmin/users");
                } else {
                    navigate(redirectTo || "/user/dashboard");
                }
            } else {
                alert(isEnglish ? "Google sign-in failed." : "ورود با گوگل ناموفق بود");
            }
        };

        let attempts = 0;
        const timer = setInterval(() => {
            attempts += 1;
            if (window.google?.accounts?.id && btnRef.current) {
                clearInterval(timer);
                window.google.accounts.id.initialize({
                    client_id: GOOGLE_CLIENT_ID,
                    callback: handleCredential,
                    auto_select: false,
                    cancel_on_tap_outside: true,
                });
                window.google.accounts.id.renderButton(btnRef.current, {
                    type: "standard",
                    theme: "outline",
                    size: "large",
                    text,
                    shape: "rectangular",
                    width: Math.min(btnRef.current.offsetWidth || 320, 400),
                });
            }
            if (attempts >= 20) clearInterval(timer);
        }, 250);

        return () => clearInterval(timer);
    }, [isEnglish, navigate, redirectTo, text]);

    return (
        <div className="flex justify-center w-full">
            <div ref={btnRef} className="flex w-full justify-center"></div>
        </div>
    );
};

export default GoogleLoginButton;
